import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from "vue";
import { RouteLocationRaw } from "vue-router";
import MenuLinkItemContent from "@/components/organisms/mypage/MenuLinkItemContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuRouterLinkItem',
  props: {
  label: {
    type: String,
    required: false
  },
  to: {
    type: Object as PropType<RouteLocationRaw>,
    required: true
  }
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: props.to,
    class: "d-block py-3 menu-item"
  }, {
    default: _withCtx(() => [
      _createVNode(MenuLinkItemContent, {
        label: props.label
      }, {
        left: _withCtx(() => [
          _renderSlot(_ctx.$slots, "left")
        ]),
        right: _withCtx(() => [
          _renderSlot(_ctx.$slots, "right")
        ]),
        bottom: _withCtx(() => [
          _renderSlot(_ctx.$slots, "bottom")
        ]),
        _: 3
      }, 8, ["label"])
    ], undefined, true),
    _: 3
  }, 8, ["to"]))
}
}

})